// LA MARCA DEL PRODUCTO.
//
// Biango es el software; la clínica es el cliente. Hasta ahora la cabecera del menú lateral pintaba
// el icono y el nombre de la CLÍNICA, así que la aplicación no se presentaba en ningún sitio: quien
// la usaba todos los días no llegaba a saber cómo se llamaba. Decisión del dueño (18-ago-2026):
// arriba va Biango.
//
// El dibujo NO está aquí: vive en /biango-marca.svg, y ese fichero es el único sitio donde está la
// marca (lo comparte con el favicon). Desde el 19-ago-2026 ese SVG es el icono de aplicación del
// cuaderno de marca aprobado, copiado de branding/svg/icono-app.svg: para cambiarlo se sustituye
// allí, se copia aquí y no hay que tocar ni este componente ni el Layout.
//
// El `?v=` no es decorativo: el navegador y el service worker cachean estos ficheros con mucha
// alegría, y sin él la marca vieja se quedaba pegada semanas. Al cambiar el dibujo, sube el número.
export const MARCA_SRC = '/biango-marca.svg?v=3';
export const MARCA_NOMBRE = 'Biango';
// LA WEB DEL PRODUCTO. El sello del pie de las pantallas de paciente (components/PieBiango) enlaza
// aqui: quien lo lee es gente de FUERA de la clinica —el paciente que firma en su movil— y ese pie
// es la unica puerta por la que puede llegar a saber que es Biango. Nombrar la marca sin decir
// donde encontrarla deja el sello a medias. Vive AQUI, junto al nombre y al dibujo, porque la marca
// tiene un solo sitio: el dia que cambie el dominio se cambia una linea y no seis pantallas.
export const MARCA_WEB = 'https://biango.es';

export default function MarcaBiango({ size = 36, radio = 10, style = {} }) {
  return (
    <img
      src={MARCA_SRC}
      alt={MARCA_NOMBRE}
      width={size}
      height={size}
      style={{ width: size, height: size, borderRadius: radio, flexShrink: 0, display: 'block', ...style }}
    />
  );
}
